/* eslint-disable @typescript-eslint/no-explicit-any*/
export const refresh = (): void => {
  setTimeout(() => {
    const evt = document.createEvent('UIEvents');
    (evt as any).initUIEvent('resize', true, false, window, 0);
    window.dispatchEvent(evt);
  }, 50);
};
